import { Box, styled } from "@mui/material";

const StyledBoxFill = styled(Box)({
  width: "100%",
});

export default StyledBoxFill;
